var styleDataHash = '1f627cb5';  
export const injectCss = (() => {
  var css = `.glob_fontElementMap,.isKq3{font-family:var(--ricos-font-family,unset)}.WPXMm{color:var(--ricos-custom-hashtag-color,var(--ricos-action-color,var(--ricos-custom-p-color,#116dff)));font-family:var(--ricos-custom-hashtag-font-family,unset);font-size:var(--ricos-custom-hashtag-font-size,unset);font-style:var(--ricos-custom-hashtag-font-style,unset);font-weight:var(--ricos-custom-hashtag-font-weight,unset);letter-spacing:var(--ricos-custom-hashtag-letter-spacing,unset);line-height:var(--ricos-custom-hashtag-line-height,unset);min-height:var(--ricos-custom-hashtag-min-height,unset);text-decoration:var(--ricos-custom-hashtag-text-decoration,none)}.WPXMm:hover{text-decoration:underline}@supports not (contain:inline-size){@media only screen and (max-width:640px){.WPXMm{font-size:var(--ricos-custom-hashtag-font-size,unset)}}}@container (width < 640px){.WPXMm{font-size:var(--ricos-custom-hashtag-font-size,unset)}}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





